<template>
  <div>
    <el-dialog
      :title="`Course Name:${courseTitle} (${lessonNumber} )`"
      :visible.sync="dialogTimeVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-row>
        <el-col :span="24">
          <span>Time Zone: {{ timezone }}</span>
        </el-col>
      </el-row>

      <div class="card-based">
        <el-card v-for="(lessonItem, index) in list" v-bind:key="lessonItem.id">
          <div slot="header" class="clearfix">
            <span>No: {{ index + 1 }}</span>
          </div>
          <div>
            <label>Begin</label>
            {{ lessonItem.beginTime }}
          </div>
          <div>
            <label>End</label>
            {{ lessonItem.endTime }}
          </div>
          <div>
            <label>Zoom ID</label>
            {{ lessonItem.zoomId }}
          </div>
          <div>
            <label>Zoom Pwd</label>
            {{ lessonItem.zoomPwd }}
          </div>
          <div>
            <label>Zoom Host Key</label>
            {{ lessonItem.zoomHostKey }}
          </div>
          <div>
            <label>Status</label>
            {{ lessonItem.timeStatus | statusTrans }}
          </div>
        </el-card>
      </div>

      <div class="list-based">
        <el-table
          :data="list"
          border
          fit
          highlight-current-row
          style="width:100%;height:300px;margin-top:30px;overflow-y:scroll;"
        >
          <el-table-column align="center" label="No" width="50">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Begin" width="175">
            <template slot-scope="scope">
              {{ scope.row.beginTime }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="End" width="175">
            <template slot-scope="scope">
              {{ scope.row.endTime }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Zoom ID" width="120">
            <template slot-scope="scope">
              {{ scope.row.zoomId }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Zoom Pwd" width="120">
            <template slot-scope="scope">
              {{ scope.row.zoomPwd }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Zoom Host Key" width="140">
            <template slot-scope="scope">
              {{ scope.row.zoomHostKey }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Status" width="120">
            <template slot-scope="scope">
              {{ scope.row.timeStatus | statusTrans }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<style>

.el-card {
  margin-top: 5px;
  margin-bottom: 5px;
}
.el-card div {
  margin-bottom: 5px;
}
@media (max-width: 800px) {
  .card-based {
    display: block;
  }
  .list-based {
    display: none;
  }
}
@media (min-width: 800px) {
  .card-based {
    display: none;
  }
  .list-based {
    display: block;
  }
}

</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TimeDialog',
  filters: {
    statusTrans(status) {
      if (status === 'not_started') {
        return '未上課'
      } else {
        return '已上課'
      }
    }
  },
  props: {
    dialogTimeVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      lessonId: 0,
      lessonNumber: '',
      courseTitle: '',
      list: [],
      lessonStatusOptions: [
        { 'value': 'not_started', 'label': '未上課' },
        { 'value': 'finished', 'label': '已完課' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'timezone'
    ])
  },
  methods: {
    open() {
      this.lessonId = this.$parent.currentTimeListLessonId
      this.lessonNumber = this.$parent.currentTimeListLessonNumber
      this.courseTitle = this.$parent.currentTimeListCourseTitle
      this.list = this.$parent.currentTimeListData
    },
    handleClose(done) {
      this.list = null
      this.lessonId = 0
      this.lessonNumber = ''
      this.courseTitle = ''
      this.$parent.dialogTimeVisible = false
    }
  }
}
</script>
